import * as React from 'react';
import BasicCard from './BasicCard';
import Filter from "../components/Filter";
import DataTable from "../components/DataTable";
import MainLayout from './MainLayout';
import Dummylayout from './Dummylayout';
import SubData from '../components/SubData';



function SubGoalTable() {
    return (
        <>
           <div> <Dummylayout/></div>
        <div className='' > <BasicCard>
                {/* <Filter/> */}
                <div className='row border-1'>
      <div className='col-lg-6'>
        <h4 className="text-start pb-3">SUB KPI</h4>
      </div>
      {/* <div className='col-lg-6 text-end bg-white '>
      <a href='GoalsForm' className="text-decoration-none text-white" ><button type="button" class="btn btn-danger rounded-pill">Add Goals</button></a>
      </div> */}
     
      </div>
      
                <SubData/>

            </BasicCard>
            </div>  
        </>
    )
}
export default SubGoalTable;